import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import { useLocalization } from "@i18n";
import { getErrorInfo } from "../utils/errorHandlers";
import { logError } from "../utils/errorLogger";
import type { ErrorInfo } from "../types";

export const useErrorInfo = (): {
  error: unknown;
  errorInfo: ErrorInfo;
  is404: boolean;
} => {
  const error = useRouteError();
  const { translate } = useLocalization();

  const is404 = isRouteErrorResponse(error) && error.status === 404;

  if (!is404) {
    logError(error, {
      errorBoundary: "RouteErrorBoundary",
      route: window.location.pathname,
    });
  }

  const errorInfo = getErrorInfo(error, translate);

  return {
    error,
    errorInfo,
    is404,
  };
};
